import React, {useEffect, useLayoutEffect} from "react";
import styled from "styled-components";
import {useNavigate, useNavigationType} from "react-router";
import {batch, useDispatch, useSelector} from "react-redux";
import {
	fetchDetailBranchPageScroll,
	fetchVoucherInfo,
	fetchBranchVoucherInfo,
	updateBranchVoucherInfoList
} from "redux/slices/sales/salesSlice";

import {getCommaNumber} from "utils/format";
import iconChevron from "assets/icons/icon_chevron_black.svg";

import Filter from "components/ui/Filter";
import Observer from "components/ui/Observer";



/**
 * [전지점 이용권 종류별 매출 목록]
 */

export const BranchDetailList = (props) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const navigationType = useNavigationType();

	const {
		searchPartner,
		searchBranch,
		searchDate,
		searchPeriodType,
		searchFilter,
		data,
		dataList,
		pageState
	} = useSelector(state => state.sales.branchVoucherInfo);

	useLayoutEffect(() => {
		dispatch(fetchDetailBranchPageScroll("restore"));
	}, []);

	useEffect(() => {
		const isUpdate = (
			!data || navigationType != "POP" || (
				searchPartner != data.searchInfo.searchPartner ||
				searchBranch != data.searchInfo.searchBranch ||
				searchDate != data.searchInfo.searchDate ||
				searchPeriodType != data.searchInfo.searchPeriodType ||
				searchFilter != data.searchInfo.searchFilter
			)
		);
		if(isUpdate) {
			if(pageState != undefined) {
				dispatch(updateBranchVoucherInfoList(false));
			}
		}
	}, [searchPartner, searchBranch, searchDate, searchPeriodType, searchFilter]);

	const eventHandler = {
		update : () => {
			dispatch(updateBranchVoucherInfoList(true));
		},
		changeFilter : (name, value) => {
			dispatch(fetchBranchVoucherInfo({
				searchFilter : value
			}));
		},
		detail : (seqPartnerBranch) => {
			batch(() => {
				dispatch(fetchVoucherInfo({
					searchPartner : searchPartner,
					searchBranch : seqPartnerBranch,
					searchDate : searchDate
				}));
				navigate("/sales/voucher/" + seqPartnerBranch);
			});
		},
	};

	const render = () => {
		const getBranchList = () => {
			const li = (dataList || []).map((item, index) => {
				return (
					<li key={item.seqPartnerBranch || index}>
						<a onClick={() => {eventHandler.detail(item.seqPartnerBranch)}}>
							<ul>
								<li>
									<div>{item.branchName}</div>
									<div>{getCommaNumber(item.totalSalesAmount)}원</div>
								</li>
								<li>
									<div>개인레슨<span>{item.appointmentSalesPercent || 0}%</span></div>
									<div>{getCommaNumber(item.appointmentSalesAmount)}원</div>
								</li>
								<li>
									<div>그룹수업<span>{item.classSalesPercent || 0}%</span></div>
									<div>{getCommaNumber(item.classSalesAmount)}원</div>
								</li>
								<li>
									<div>시설이용<span>{item.placeSalePercent || 0}%</span></div>
									<div>{getCommaNumber(item.placeSaleAmount)}원</div>
								</li>
								<li>
									<div>옵션이용<span>{item.optionSalesPercent || 0}%</span></div>
									<div>{getCommaNumber(item.optionSalesAmount)}원</div>
								</li>
								<li>
									<div>패키지<span>{item.packageSalePercent || 0}%</span></div>
									<div>{getCommaNumber(item.packageSaleAmount)}원</div>
								</li>
							</ul>
						</a>
					</li>
				);
			});
			return (<ul>{li}</ul>);
		};

		const filterList = [{
			label : "매출순",
			value : "SALES",
		}, {
			label : "이름순",
			value : "NAMES"
		}];

		return (
			<Wrapper>
				<Filter
					title="이용권 종류 선택" value={searchFilter}
					options={filterList} onChange={eventHandler.changeFilter}
					isSticky={true}
				/>
				<div className="list">
					{getBranchList()}
				</div>
				<Observer isActive={pageState} isLoading={true} onVisible={eventHandler.update} />
			</Wrapper>
		);
	};
	return render();
};

const Wrapper = styled.div`
.list									{padding:0 24px}
.list > ul > li a						{display:block; padding:20px 0}
.list > ul > li + li					{border-top:1px solid var(--lightBorder)}

.list ul ul li							{display:flex; align-items:center; justify-content:space-between}
.list li div + div						{text-align:right; color:var(--darkGray)}

.list li div:first-child				{font-size:var(--16px)}
.list li ul li							{padding:2px 0}
.list li ul li:first-child				{margin-bottom:2px}
.list li ul li:first-child div			{font-size:var(--18px); font-weight:600}
.list li ul li:first-child div + div	{margin-right:-2px; padding-right:0.75em; background:url(${iconChevron}) no-repeat center right; color:var(--black)}
.list li div span						{font-size:var(--14px); color:var(--gray)}
.list li div span:before				{content:" · "}
`;

export default BranchDetailList;